// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"roles_actions___buttonWrapper___faa734a2"};